import { render } from "./onlineSignals.vue?vue&type=template&id=0f57bb2a&scoped=true"
import script from "./onlineSignals.vue?vue&type=script&lang=js"
export * from "./onlineSignals.vue?vue&type=script&lang=js"

import "./onlineSignals.vue?vue&type=style&index=0&id=0f57bb2a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f57bb2a"]])

export default __exports__